// extracted by mini-css-extract-plugin
module.exports = {"container":"blog-post-module--container--3EKsY","page":"blog-post-module--page--2lnFJ","content":"blog-post-module--content--c97Ib","carousel":"blog-post-module--carousel--1vQvR"};